export var DEFAULT_COLOR = ['#FAAD14', '#E8EDF3'];